var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "v2 (Stroke)",
    opacity: 0.4,
    d: "M13.75 1.80469C13.75 1.11433 14.3096 0.554688 15 0.554688H17.5C18.1904 0.554688 18.75 1.11433 18.75 1.80469V16.8047H19.375C19.7202 16.8047 20 17.0845 20 17.4297C20 17.7749 19.7202 18.0547 19.375 18.0547H0.625C0.279822 18.0547 0 17.7749 0 17.4297C0 17.0845 0.279822 16.8047 0.625 16.8047H1.25V13.0547C1.25 12.3643 1.80964 11.8047 2.5 11.8047H5C5.69036 11.8047 6.25 12.3643 6.25 13.0547V16.8047H7.5V8.05469C7.5 7.36433 8.05964 6.80469 8.75 6.80469H11.25C11.9404 6.80469 12.5 7.36433 12.5 8.05469V16.8047H13.75V1.80469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v2 (Stroke)_2",
    d: "M13.75 1.80469C13.75 1.11433 14.3096 0.554688 15 0.554688H17.5C18.1904 0.554688 18.75 1.11433 18.75 1.80469V16.8047H19.375C19.7202 16.8047 20 17.0845 20 17.4297C20 17.7749 19.7202 18.0547 19.375 18.0547H0.625C0.279822 18.0547 0 17.7749 0 17.4297C0 17.0845 0.279822 16.8047 0.625 16.8047H1.25V13.0547C1.25 12.3643 1.80964 11.8047 2.5 11.8047H5C5.69036 11.8047 6.25 12.3643 6.25 13.0547V16.8047H7.5H12.5C11.8096 16.8047 12 16.8047 12.5 16.8047H13.75V1.80469Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.9a535cdc2bfb4f0e9dae1682e81ea725.svg";
export { ForwardRef as ReactComponent };